import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.308 2.279a1 1 0 0 1 1.384 0l7 6.717a1 1 0 0 1-1.384 1.443l-5.276-5.063V20a1 1 0 1 1-2 0V5.315l-5.34 5.124a1 1 0 0 1-1.384-1.443l7-6.717Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
